type Props = {
  barColor: string;
  color: string;
  height: string;
  width: string;
};

const LoadingBar = ({ barColor, color, height, width }: Props) => {
  return (
    <div
      className={`relative h-2 ${width} overflow-hidden rounded ${barColor}`}
    >
      <div
        className={`absolute top-0 animate-progress ${height} w-[20%] translate-x-[-500%] rounded ${color}`}
      />
    </div>
  );
};

export default LoadingBar;
